module.exports = __webpack_public_path__ + "img/Group 8469.0e005175.svg";